import { Videos } from '../_app/cuchillo/components/Videos';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Cmp from '../windows/Cmp';
import BGVideo from '../layout/BGVideo';

export default class NoScroll extends Page {

    constructor() {
    super();

    Videos.init();
    BGVideo.start(()=>{this.videoLoaded()});
    }

    videoLoaded() {}

    //SHOW
    beforeShow() {
        super.beforeShow();
        Keyboard.mountPage(this.id);
    }

    show__effect(__call) {
        if (this.isFirstTime) {
            Wrap.directShow();
            Preloader.hide(() => { this.afterShow() });
        } else {
            Wrap.show(() => { this.afterShow() });
        }
    }
    

    afterShow() {
        super.afterShow();
    }

    //HIDE
    beforeHide() {
        Keyboard.unmountPage(this.id);
        super.beforeHide();
    }

    hide__effect() {
        BGVideo.hide();
        Wrap.hide(() => { this.afterHide(); });
    }

    afterHide() {
        super.afterHide();
        this.dispose();
        document.body.classList.remove('__noScroll');
    }

    dispose() {
        Videos.dispose();
    }

    //RESIZE
    resize() {
        super.resize();
    }

    //LOOP
    loop() {
        if (this._isActive) {
        super.loop();
        }
    }
}

ControllerPage._addPage('no-scroll', NoScroll);